import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const hudForm = {
  fields: {
    borrowerCashAtClosing: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Borrower cash to close is required.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class HudFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...hudForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}
